import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import SubPageTitle from 'components/_common/panel/SubPageTitle';
import { Button } from 'components/_new/Button';
import { useProgramPanel } from 'contexts/programPanelContext';
import { ModifyTimelineEventForm } from './ModifyTimelineEventForm';

export const ProgramTimelineEventAdd = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { data: program, panelPath } = useProgramPanel();

	return (
		<>
			<Helmet title={t('timeline.programPanel.addTitle')} />
			<SubPageTitle
				title={t('timeline.programPanel.addTitle')}
				additional={program?.displayName}
				right={() => (
					<Button
						icon="arrow-left"
						variant="primary-text"
						variantSize="sm"
						onClick={() => {
							navigate(`/${panelPath}/timeline`);
						}}
						label={t('actions.back')}
					/>
				)}
			/>
			<ModifyTimelineEventForm />
		</>
	);
};
